var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    fill: "#fff",
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.893h10.5",
    stroke: "#91928e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-minus-35c4cbdc0404c9cf3c296e36b5bfa05b.svg";
export { SvgIconCircleMinus as Component };